import { useTranslation } from 'react-i18next';
import { NameColorPopoverForm } from './NameColorPopoverForm';
import type { StatusPopoverFormValues } from '../schemas';

interface StatusPopoverFormProps {
  onAdd: (values: StatusPopoverFormValues) => void;
  isPending?: boolean;
}

export function StatusPopoverForm({ onAdd, isPending }: StatusPopoverFormProps) {
  const { t } = useTranslation('projectTemplates');

  const typeOptions = [
    { value: 'Todo', label: t('popovers.status.types.todo') },
    { value: 'InProgress', label: t('popovers.status.types.inProgress') },
    { value: 'Done', label: t('popovers.status.types.done') },
  ];

  return (
    <NameColorPopoverForm
      kind="status"
      title={t('popovers.status.title')}
      nameLabel={t('popovers.status.nameLabel')}
      addLabel={t('popovers.status.add')}
      addAriaLabel={t('preview.addStatus')}
      onSubmit={(values) => onAdd(values as StatusPopoverFormValues)}
      isPending={isPending}
      testIdPrefix="project-templates-status"
      typeLabel={t('popovers.status.typeLabel')}
      typeOptions={typeOptions}
    />
  );
}
